export const ratingData = [
  {
    place: 1,
    name: "Олена Р.",
    avg: 7308,
    upsell: "95%",
    leads: 55,
    combo: 14,
  },
  { place: 2, name: "Ігор М.", avg: 7108, upsell: "90%", leads: 59, combo: 14 },
  { place: 3, name: "Ви", avg: 6508, upsell: "88%", leads: 51, combo: 14 },
  {
    place: 4,
    name: "Світлана К.",
    avg: 6258,
    upsell: "85%",
    leads: 45,
    combo: 3,
  },
  {
    place: 5,
    name: "Андрій С.",
    avg: 5908,
    upsell: "82%",
    leads: 47,
    combo: 8,
  },
];

export const periodOptions = ["1 день", "1-10", "11-20", "21-31"];
